exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrollable-tab-content {\n  max-height: 65vh;\n  overflow-y: auto;\n  overflow-x: auto;\n}\nh5,\nh6 {\n  font-weight: 600;\n}\n.metadata-list-item div {\n  display: inline !important;\n}\n.metadata-list-group-item {\n  border-left: none;\n  border-right: none;\n  padding: 0.75rem 0rem;\n}\n.metadata-list-group-item:first-child {\n  border-top: none;\n}\n", ""]);

// exports
